shadow$provide[279] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Memo:{enumerable:true, get:function() {
  return Memo;
}}});
var require$_DOT__SLASH_operator = require("./operator");
class Memo extends require$_DOT__SLASH_operator.Operator {
  static initClass() {
    this.traits = ["node", "bind", "active", "operator", "source", "index", "texture", "memo",];
  }
  sourceShader(shader) {
    return this.memo.shaderAbsolute(shader, 1);
  }
  make() {
    super.make();
    if (this.bind.source == null) {
      return;
    }
    this._helpers.active.make();
    this._listen("root", "root.update", () => {
      if (this.isActive) {
        return this.update();
      }
    });
    const {minFilter, magFilter, type} = this.props;
    const dims = this.bind.source.getDimensions();
    const {items, width, height, depth} = dims;
    this.memo = this._renderables.make("memo", {items, width, height, depth, minFilter, magFilter, type,});
    const operator = this._shaders.shader();
    this.bind.source.sourceShader(operator);
    this.compose = this._renderables.make("memoScreen", {map:operator, items, width, height, depth,});
    this.memo.adopt(this.compose);
    this.objects = [this.compose];
    return this.renders = this.compose.renders;
  }
  unmake() {
    this._helpers.active.unmake();
    if (this.bind.source != null) {
      this.memo.unadopt(this.compose);
      this.memo.dispose();
      this.memo = this.compose = null;
      super.unmake();
    }
  }
  update() {
    return this.memo != null ? this.memo.render() : undefined;
  }
  resize() {
    if (this.bind.source == null) {
      return;
    }
    const dims = this.bind.source.getActiveDimensions();
    const {width, height, depth} = dims;
    this.compose.cover(width, height, depth);
    return super.resize();
  }
  change(changed, touched, _init) {
    if (touched["texture"] || touched["operator"]) {
      return this.rebuild();
    }
  }
}
Memo.initClass();

};